import { render, staticRenderFns } from "./collapsible-box-stack.vue?vue&type=template&id=489b07fc&"
import script from "./collapsible-box-stack.vue?vue&type=script&lang=js&"
export * from "./collapsible-box-stack.vue?vue&type=script&lang=js&"
import style0 from "./collapsible-box-stack.vue?vue&type=style&index=0&id=489b07fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports